<template>
  <div class="d-flex justify-content-center">
    <div class="flex-column  justify-content-center align-item-center">
     <h3 class="text-center py-4">{{ $t("page_notFound") }}</h3>
      <img src="../assets/giphy.webp" alt="404 Not found Image">
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
  metaInfo: {
    title: 'Not Found',
  },
};
</script>

<style lang="scss" scoped></style>
